import { DownloadButton, LoadButton } from './buttons';
import { EmailAutocomplete } from './inputs/index';
import TableToolBox from './table-tool-box';
import PanelBox from './panel-box';
import GoogleMaps from './google-maps';
import PaginationBox from './pagination-box';
import SearchBoxComponent from './search-box';
import Odometer from './odometer';
import { comisions } from './table';
import { Loader } from '../modals';
export default {
    install: function install(vue, options) {
        vue.component('search-box', SearchBoxComponent);
        vue.component('table-tool-box', TableToolBox);
        vue.component('panel-box', PanelBox);
        vue.component('pagination-box', PaginationBox);
        vue.component('download-button', DownloadButton);
        vue.component('google-maps', GoogleMaps);
        vue.component('email-autocomplete', EmailAutocomplete);
        vue.component('load-button', LoadButton);
        vue.component('odometer', Odometer);
        vue.component('comisions', comisions);
        vue.component('loader', Loader);
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/index.js
// module id = ./src/components/shared/index.js
// module chunks = 34